"use strict";
import { __require as q } from "./index.es226.js";
import { __require as M } from "./index.es227.js";
import { __require as _ } from "./index.es104.js";
import { __require as W } from "./index.es106.js";
import { __require as w } from "./index.es103.js";
var o, f;
function G() {
  if (f) return o;
  f = 1;
  var s = /* @__PURE__ */ q(), n = /* @__PURE__ */ M(), c = /* @__PURE__ */ _(), i = W(), l = /* @__PURE__ */ w(), a = s("%WeakMap%", !0), m = n("WeakMap.prototype.get", !0), d = n("WeakMap.prototype.set", !0), h = n("WeakMap.prototype.has", !0), v = n("WeakMap.prototype.delete", !0);
  return o = a ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var r, t, p = {
        assert: function(e) {
          if (!p.has(e))
            throw new l("Side channel does not contain " + c(e));
        },
        delete: function(e) {
          if (a && e && (typeof e == "object" || typeof e == "function")) {
            if (r)
              return v(r, e);
          } else if (i && t)
            return t.delete(e);
          return !1;
        },
        get: function(e) {
          return a && e && (typeof e == "object" || typeof e == "function") && r ? m(r, e) : t && t.get(e);
        },
        has: function(e) {
          return a && e && (typeof e == "object" || typeof e == "function") && r ? h(r, e) : !!t && t.has(e);
        },
        set: function(e, u) {
          a && e && (typeof e == "object" || typeof e == "function") ? (r || (r = new a()), d(r, e, u)) : i && (t || (t = i()), t.set(e, u));
        }
      };
      return p;
    }
  ) : i, o;
}
export {
  G as __require
};
//# sourceMappingURL=index.es107.js.map
